import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取秒杀商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listProductSeckill(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/productSeckill.listProductSeckill',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加秒杀商品
 * @param {Object} data 商品数据
 * @returns {Promise} Promise对象
 */
export function saveProductSeckill(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productSeckill.saveProductSeckill',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新秒杀商品
 * @param {Object} data 商品数据
 * @returns {Promise} Promise对象
 */
export function updateProductSeckill(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productSeckill.updateProductSeckill',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除秒杀商品
 * @param {Object} data 商品数据
 * @returns {Promise} Promise对象
 */
export function deleteProductSeckill(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productSeckill.deleteProductSeckill',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}